<script>
    import { mapState, mapActions, mapMutations } from 'vuex';
    import isEmpty from 'lodash/isEmpty';

    import C1FormInput from '@/components/C1Components/C1FormInput';
    import C1Select from '@/components/C1Components/C1Select';
    import C1Button from '@/components/C1Components/C1Button';
    import C1Typeahead from '@/components/C1Components/C1Typeahead';
    import ClassificationSelecter from '@/components/C1Components/ClassificationSelecter';

    export default {
        name: 'SearchBarMixin',

        components: {
            C1FormInput,
            C1Select,
            C1Button,
            C1Typeahead,
            ClassificationSelecter,
        },

        data() {
            return {
                locationsSelected: [],
                locationsSearched: [],
                inputKeyword: this.$_searchFilters?.search_keywords ? this.$_searchFilters.search_keywords : '',
                closeClassificationDropdown: false,
            };
        },

        computed: {
            ...mapState({
                $_searchFilters: state => state.search.searchPayload.search_filters,
                $_jobLocations: state => state.location.locations,
            }),

            keyword: {
                get() {
                    return this.inputKeyword;
                },

                set(value) {
                    this.inputKeyword  = value;
                },
            },

            location: {
                get() {
                    return !isEmpty(this.$_searchFilters.location) ? this.$_searchFilters.location : {};
                },

                set(location) {
                    this.$_SET_SEARCH_FILTERS({ key: 'location', value: location, preventSearch: true });
                },
            },

            classifications: {
                get() {
                    return this.$_searchFilters.classifications ? this.$_searchFilters.classifications : [];
                },

                set(classifications) {
                    this.$_SET_SEARCH_FILTERS({ key: 'classifications', value: classifications, preventSearch: true });
                },
            },
        },

        methods: {
            ...mapActions('location', {
                $_getLocations: 'getLocations',
            }),

            ...mapMutations('search', {
                $_SET_SEARCH_FILTERS: 'SET_SEARCH_FILTERS',
            }),

            searchLocations(str) {
                this.spinner.location = true;
                const keyword = str.toLowerCase();

                this.$_getLocations({ query: keyword}).then((res) => {
                    const searchResults = res.data;
                    this.locationOptions = [...searchResults];
                    this.spinner.location = false;
                });
            },

            onLocationSelect(location) {
                if(location !== null) {
                    this.location = location;  
                }
                else{
                    this.location = {};
                }
            },

            searchClassification(classifications) {
                this.$_SET_SEARCH_FILTERS({ key: 'classifications', value: classifications, preventSearch: true });
                this.closeClassificationDropdown = false;
            },

            handleSearch() {
                this.closeClassificationDropdown = true;
                const search_words = this.inputKeyword.trim();
                this.$_SET_SEARCH_FILTERS({ key: 'search_keywords', value: search_words, preventSearch: true });
                this.inputKeyword = '';
                this.$emit('search');
            },
        },
    };
</script>
